// app/javascript/controllers/text_counter_controller.js
import { Controller } from "@hotwired/stimulus"

/**
 * Manages character counting for text inputs like engravings
 * Prevents input beyond the maximum allowed length
 */
export default class extends Controller {
  static targets = ["input", "counter"]
  static values = {
    maxLength: Number
  }
  
  connect() {
    this.updateCounter()
    this.limitText()
  }
  
  updateCounter() {
    const remainingChars = this.maxLengthValue - this.inputTarget.value.length
    this.counterTarget.textContent = Math.max(0, remainingChars)
  }
  
  limitText() {
    // If text exceeds max length, truncate it
    if (this.inputTarget.value.length > this.maxLengthValue) {
      this.inputTarget.value = this.inputTarget.value.substring(0, this.maxLengthValue)
    }
  }
  
  // Method triggered by input events
  processInput(event) {
    // If attempting to type beyond limit, prevent it
    if (this.inputTarget.value.length >= this.maxLengthValue && 
        !event.inputType.startsWith('delete')) {
      event.preventDefault()
    }
    
    this.limitText()
    this.updateCounter()
  }
}
